import {Editor} from '@tiptap/react';
import {t} from 'i18next';
import React, {useState} from 'react';
import {validateURL} from '../../../../../utils/urlValidator';
import Modal from '../../../../../incase-domain/components/modals/directory/Modal';
import TextEditorButton from '../../../../../incase-domain/components/textEditor/TextEditorButton';
import {TypedTranslation} from '../../../../../i18n';

interface LinkEditorButtonProps {
    editor: Editor;
}

export function LinkEditorButton(props: LinkEditorButtonProps): JSX.Element {
    const {editor} = props;

    const [isOpen, setIsOpen] = useState(false);

    const [url, setUrl] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleLinkToggle = (newUrl: undefined | string): void => {
        setErrorMessage('');
        if (!newUrl) {
            editor.chain().focus().unsetLink().run();
            setIsOpen(false);
            return;
        }

        const validation = validateURL(newUrl);
        if (validation.isValid) {
            editor.chain().focus().extendMarkRange('link').setLink({href: newUrl}).run();
            setIsOpen(false);
        } else {
            setErrorMessage(validation.error);
        }
    };

    return (
        <>
            <TextEditorButton
                icon="solar:link-linear"
                onClick={() => {
                    const tempUrl = editor.getAttributes('link').href;
                    setUrl(tempUrl);
                    setIsOpen(true);
                }}
                isActive={editor.isActive('link')}
            />
            <Modal
                description={t('presEditPage.header.textEditor.urlModalTitle')}
                header={`"${editor.state.doc.textBetween(editor.state.selection.from, editor.state.selection.to, ' ')}"`}
                icon="solar:link-bold"
                isOpen={isOpen}
                showCancel
                showConfirm
                closeOnClickOutside={false}
                onCancel={() => {
                    setErrorMessage('');
                    setIsOpen(false);
                }}
                onConfirm={() => {
                    handleLinkToggle(url);
                }}
            >
                <div className={`c-sidepanel__input ${errorMessage ? 'is-error' : ''}`}>
                    <input
                        className="c-sidepanel__input"
                        type="text"
                        placeholder="https://nobula.eu"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                    />
                    {errorMessage && <div className="l-group__item_error">{t(errorMessage as TypedTranslation)}</div>}
                </div>
            </Modal>
        </>
    );
}
